"use client"

import { useState, useCallback } from "react"

export interface Toast {
  title: string
  description?: string
  variant?: "default" | "destructive"
}

type ToastState = Toast[]

const TOAST_LIMIT = 5
const TOAST_REMOVE_DELAY = 3000

type UseToastReturn = {
  toasts: ToastState
  toast: (data: Toast) => void
  dismiss: (toastId?: string) => void
}

// Create a context-less hook
export function useToast(): UseToastReturn {
  const [toasts, setToasts] = useState<ToastState>([])

  const toast = useCallback((data: Toast) => {
    setToasts((state) => [...state, data].slice(-TOAST_LIMIT))
  }, [])

  const dismiss = useCallback((toastId?: string) => {
    setToasts((state) => (toastId ? state.filter((toast) => toast.title !== toastId) : []))
  }, [])

  return {
    toasts,
    toast,
    dismiss,
  }
}

